import { Injectable, inject } from '@angular/core';
import ServiceRestServices from '../services/service-rest.service';
import AngularHelperService from '../services/angular-helper.service';

@Injectable({ providedIn: 'root' })
export default class BookingService {
	private serviceRestServices: ServiceRestServices = inject(ServiceRestServices);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	getUnfinishedBooking(serviceId) {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		this.serviceRestServices.activeBookings({ forBusiness: false, status: 'BOOKED' },
			(bookings) => {
				bookings = bookings || [];
				var booking: any = bookings.filter((item) => { return item.service.id === serviceId; })[0];
				deferred.resolve(booking);
			},
			(err) => {
				console.log(err);
				deferred.reject();
			});
		
		return deferred.promise;
	}
	
}